import React from 'react';

function FeedingAmountProportions(props) {
  const {productProportions, data, dataProduct, snackPortion, wetPortion, dryPortion,
    relatedPortion, dryWeight, wetWeight, availableCategories} = props;

  const dryWeightValid = typeof dryWeight == "number";
  const wetWeightValid = typeof wetWeight == "number";
  const relatedPortionValid = relatedPortion !== "0.00";

  return  (
    <div className="row nppe2-fc-type-of-food-bar">

      {
        availableCategories.includes("dry") ?
          <div className="col-xs-6 col-lg-3">
            <div className="nppe2-fc-type-of-food-bar__icon
                            nppe2-fc-type-of-food-bar__icon-dry-food">
            </div>
            <div className="nppe2-fc-type-of-food-bar__info">
              <div className="nppe2-fc-type-of-food-bar__info-title">{dataProduct.labelDry}</div>
                {dryWeightValid &&
                  <div className="nppe2-fc-type-of-food-bar__info-data">{dryWeight}{data.g}/{dryPortion}{data.kcal}</div>
                }

            </div>
          </div>
        : null
      }
      {
        availableCategories.includes("wet") ?
          <div className="col-xs-6 col-lg-3">
            <div className="nppe2-fc-type-of-food-bar__icon
                            nppe2-fc-type-of-food-bar__icon-wet-food">
            </div>
            <div className="nppe2-fc-type-of-food-bar__info">
              <div className="nppe2-fc-type-of-food-bar__info-title">{dataProduct.labelWet}</div>
              {wetWeightValid &&
                <div className="nppe2-fc-type-of-food-bar__info-data">{wetWeight}{data.g}/{wetPortion}{data.kcal}</div>
              }
            </div>
          </div>
        : null
      }
      {
        availableCategories.includes("supplement") ?
          <div className="col-xs-6 col-lg-3">
            <div className="nppe2-fc-type-of-food-bar__icon
                            nppe2-fc-type-of-food-bar__icon-related-food">
            </div>
            <div className="nppe2-fc-type-of-food-bar__info">
              <div className="nppe2-fc-type-of-food-bar__info-title">{dataProduct.labelRelated}</div>
              {relatedPortionValid &&
                <div className="nppe2-fc-type-of-food-bar__info-data">{relatedPortion}{data.kcal}</div>
              }
            </div>
          </div>
        : null
      }
      {
        availableCategories.includes("snack") ?
          <div className="col-xs-6 col-lg-3">
            <div className="nppe2-fc-type-of-food-bar__icon
                            nppe2-fc-type-of-food-bar__icon-snacks-food">
            </div>
            <div className="nppe2-fc-type-of-food-bar__info">
              <div className="nppe2-fc-type-of-food-bar__info-title">{dataProduct.labelSnacks}</div>
              <div className="nppe2-fc-type-of-food-bar__info-data">{snackPortion}{data.kcal}</div>
            </div>
          </div>
        : null
      }

      <div className="col-xs-12">
        <div className="row">
          <div className="nppe2-fc-type-of-food-bar__colors">

            {productProportions.map((item, i) => {
              return (
                <div className={productProportions[i]["class"]}
                  key={i}
                  style={{width: productProportions[i]["width"] + "%"}}>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FeedingAmountProportions;
